import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=a1f2de7c&scoped=true"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=a1f2de7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f2de7c",
  null
  
)

export default component.exports